import { render, staticRenderFns } from "./shopAccountList.vue?vue&type=template&id=0ccc9e8c&scoped=true&"
import script from "./shopAccountList.vue?vue&type=script&lang=js&"
export * from "./shopAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc9e8c",
  null
  
)

export default component.exports